/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateLocationDto,
  LocationsControllerCreateV1201,
  LocationsControllerCreateV1PathParameters,
  LocationsControllerDeleteV1PathParameters,
  LocationsControllerFindAllV1200,
  LocationsControllerFindAllV1Params,
  LocationsControllerFindAllV1PathParameters,
  LocationsControllerFindOneV1200,
  LocationsControllerFindOneV1PathParameters,
  LocationsControllerUpdateV1200,
  LocationsControllerUpdateV1PathParameters,
  UpdateLocationDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class LocationsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all locations for a client
   */

  findAll<TData = LocationsControllerFindAllV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: LocationsControllerFindAllV1PathParameters,
    params?: LocationsControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/locations/v1/clients/${clientId}/locations`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Create a new location
   */

  create<TData = LocationsControllerCreateV1201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: LocationsControllerCreateV1PathParameters,
    createLocationDto: CreateLocationDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/locations/v1/clients/${clientId}/locations`, createLocationDto);
  }
  /**
   * @summary Retrieve a specific location
   */

  findOne<TData = LocationsControllerFindOneV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    locationId,
  }: LocationsControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}`);
  }
  /**
   * @summary Update an existing location
   */

  update<TData = LocationsControllerUpdateV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, locationId }: LocationsControllerUpdateV1PathParameters,
    updateLocationDto: UpdateLocationDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}`, updateLocationDto);
  }
  /**
   * @summary Delete a location
   */

  delete<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    locationId,
  }: LocationsControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}`);
  }
}
